import React from 'react';

const StatsSection = ({ stats }) => (
  <section className="py-10 sm:py-12 bg-slate-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
        {stats.map((stat, index) => (
          <div key={stat.label || index} className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-1 sm:mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
              {stat.value}
            </div>
            <div className="text-slate-400 text-xs sm:text-sm">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default StatsSection;
